import { createSlice } from '@reduxjs/toolkit';
import { getPersistedDjSidebarWidth } from '../utils/djSidebarWidth';

const initialState = {
    sidebarOpen: false,
    sidebarWidth: getPersistedDjSidebarWidth(),
    syncStatus: 'not_synced', // 'not_synced' | 'checking' | 'synced' | 'partial' (import stopped/failed, whole playlists kept) | 'error'
    traktorPath: null,
    traktorExists: null,
    traktorPlaylists: [],
    lastSyncTime: null,
    importing: false,
    exporting: false,
    error: null,
    persistedStateLoaded: false
};

const traktorSlice = createSlice({
    name: 'traktor',
    initialState,
    reducers: {
        loadPersistedTraktorState(state, action) {
            if (state.persistedStateLoaded) return;

            if (action.payload) {
                const { lastSyncTime, traktorPath, traktorPlaylists } = action.payload;
                if (lastSyncTime) {
                    state.lastSyncTime = lastSyncTime;
                    state.syncStatus = 'synced';
                }
                if (traktorPath) {
                    state.traktorPath = traktorPath;
                }
                if (traktorPlaylists && traktorPlaylists.length > 0) {
                    state.traktorPlaylists = traktorPlaylists;
                }
            }

            state.persistedStateLoaded = true;
        },
        toggleTraktorSidebar(state) {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setTraktorSidebarOpen(state, action) {
            state.sidebarOpen = action.payload;
        },
        setTraktorSidebarWidth(state, action) {
            state.sidebarWidth = action.payload;
        },
        setTraktorSyncStatus(state, action) {
            state.syncStatus = action.payload;
        },
        setTraktorPath(state, action) {
            state.traktorPath = action.payload;
        },
        setTraktorExists(state, action) {
            state.traktorExists = action.payload;
        },
        setTraktorPlaylists(state, action) {
            state.traktorPlaylists = action.payload;
        },
        setTraktorLastSyncTime(state, action) {
            state.lastSyncTime = action.payload;
        },
        setTraktorImporting(state, action) {
            state.importing = action.payload;
        },
        setTraktorExporting(state, action) {
            state.exporting = action.payload;
        },
        setTraktorError(state, action) {
            state.error = action.payload;
        },
        // Owner-scoped "Last synced" from the main process (djlibrary:getSyncState),
        // fetched on boot and on every account change by DjSyncStateHydrator.
        // Null = this account never synced this app: leave the state alone.
        hydrateTraktorSyncState(state, action) {
            const at = action.payload;
            if (!at) return;
            state.lastSyncTime = at;
            if (state.syncStatus === 'not_synced') state.syncStatus = 'synced';
        },
        resetTraktorState(state) {
            state.syncStatus = 'not_synced';
            state.traktorPlaylists = [];
            state.lastSyncTime = null;
            state.error = null;
        }
    },
});

export const {
    loadPersistedTraktorState,
    toggleTraktorSidebar,
    setTraktorSidebarOpen,
    setTraktorSidebarWidth,
    setTraktorSyncStatus,
    setTraktorPath,
    setTraktorExists,
    setTraktorPlaylists,
    setTraktorLastSyncTime,
    setTraktorImporting,
    setTraktorExporting,
    setTraktorError,
    hydrateTraktorSyncState,
    resetTraktorState
} = traktorSlice.actions;

export default traktorSlice.reducer;
